/* globals angular */
(function() {
  'use strict';

  function HistoricoCtrl (
    $state,
    betaPermission,
    localStorageService,
    Perfil
  ) {
    var vm = this;
    vm.$state = $state;
    vm.showOccurrences = betaPermission.occurrences;
    vm.showCharts = betaPermission.charts;

    Perfil.getBetaFeatures().then(function (data){

      vm.showGerenciamentoOcorrenciasV2 = data['funcionalidades'].find(function(feature){
        return feature['codigo'] == 'gerenciamento-ocorrencia-v2';
      })['possuiAcesso'];

      vm.showDevolucoes = data['funcionalidades'].find(function(feature){
        return feature['codigo'] == 'painel-devolucoes';
      })['possuiAcesso'];

    });

    vm.handleClick = function (value) {
    };
  }

  angular
    .module('mandaeApp')
    .controller('HistoricoCtrl', HistoricoCtrl);
})();
